import React, { useState, useRef, useEffect } from 'react'
import { GoogleMap, LoadScript, Marker, DirectionsRenderer, DirectionsService } from '@react-google-maps/api';
import { useLocation, useNavigate } from "react-router-dom";
import ReactLoading from 'react-loading';





const MapComponent = ({ longitude, latitude }) => {

    const [center, setcenter] = useState({
        lat: parseFloat(latitude),
        lng: parseFloat(longitude)
    });


    const [directions, setdirections] = useState('');
    const [zoomno, setzoomno] = useState(15);

    const GoogleMapsApiKey = "AIzaSyApDIOsCZmGjYdLXSNZMHD8toI_3zCtcJM"

    const containerStyle = {
        width: '100%',
        margin: "0 auto",
        height: '500px'
    };

    // const center = {
    //     lat: latitude,
    //     lng: longitude
    // };
    let color = "rgb(230, 52, 52)";
    let type = "bars";

    const handlezoom = (e) => {
        setzoomno(zoomno + 1)

    }




    return (
        <LoadScript
            googleMapsApiKey={GoogleMapsApiKey}
        >
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={zoomno}
            >
                <Marker position={center} onClick={() => handlezoom()} />
            </GoogleMap>
        </LoadScript>
    )
}

export default MapComponent;

